import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import RegistrationForm from './RegistrationForm';
import LoginForm from './LoginForm';
import LocalRegister from './localRegistar';
import Dashboard from './Dashboard';
import PaymentCallback from './PaymentCallback';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="page-container">
          <section className="full_page">
            <header className="container-fluid">
                <div className="container">
                    <div className="row">
                        <div className="col-6 col-lg-3">
                            <a href="index.html" className="logo">
                                <h1>ABMFY</h1>
                                <img src="/assets/images/logo.png" alt="ABMFY" />
                            </a>
                        </div>
                        <div className="main-menu col-lg-6">
                            <nav>
                                <ul>
                                    <li><a href="https://abmfy.com/home/index.html" className="text-secondary active">Home</a></li>
                                    <li><a href="https://abmfy.com/home/#why-abmfy" className="text-secondary">Why ABMFY?</a></li>
                                    <li><a href="https://abmfy.com/home/#how-it-works" className="text-secondary">How it works?</a></li>
                                    <li><a href="https://abmfy.com/home/#pricing" className="text-secondary">Pricing</a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="col-6 col-lg-3">
                            <div className="account-box">
                                <div className="language-box">
                                    {/* <a href="../index.html" className="text-secondary">
                                        <span>العربية</span>
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className="App-header">
              <Routes>
                <Route path="/register" element={<RegistrationForm />} />
                <Route path="/login" element={<LoginForm />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/paymentcallback" element={<PaymentCallback />} />
                <Route path="/" element={<RegistrationForm />} /> {/* Default route */}
              </Routes>
            </div>
            <section className="footer">
              <div className="container-fluid copyrights-container">
                  <div className="container">
                      <div className="row copyrights">
                          <div className="col-12 col-lg-6 text-start copyrights-box">
                              <p>All rights reserved  © ABMFY  2025 </p>
                          </div>
                          <div className="col-12 col-lg-6 text-end copyrights-box">
                              <a href="https://www.linkedin.com/company/abmfy" target="_blank" rel="noreferrer" style={{display: 'inline-block',marginTop: '12px', marginRight: '5px'}}>
                                  <svg fill="#ffffff" height="30px" width="30px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"stroke="#ffffff" strokeWidth="0.96">
                                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                      <g id="SVGRepo_iconCarrier"> <path d="M23,0H9C4,0,0,4,0,9v14c0,5,4,9,9,9h14c5,0,9-4,9-9V9C32,4,28,0,23,0z M12,25c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1V13 c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1V25z M9,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S10.7,11,9,11z M26,25c0,0.6-0.4,1-1,1h-3 c-0.6,0-1-0.4-1-1v-3.5v-1v-2c0-0.8-0.7-1.5-1.5-1.5S18,17.7,18,18.5v2v1V25c0,0.6-0.4,1-1,1h-3c-0.6,0-1-0.4-1-1V13 c0-0.6,0.4-1,1-1h4c0.3,0,0.5,0.1,0.7,0.3c0.6-0.2,1.2-0.3,1.8-0.3c3,0,5.5,2.5,5.5,5.5V25z"></path> </g>
                                  </svg>
                              </a>
                              <a href="https://wa.me/966506227067" target="_blank" rel="noreferrer" style={{display: 'inline-block',marginTop: '12px'}}>
                                  <svg fill="#ffffff" width="30px" height="30px" viewBox="0 0 16.00 16.00" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" strokeWidth="0.00016">
                                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="0.32"></g>
                                      <g id="SVGRepo_iconCarrier">
                                          <path d="M11.42 9.49c-.19-.09-1.1-.54-1.27-.61s-.29-.09-.42.1-.48.6-.59.73-.21.14-.4 0a5.13 5.13 0 0 1-1.49-.92 5.25 5.25 0 0 1-1-1.29c-.11-.18 0-.28.08-.38s.18-.21.28-.32a1.39 1.39 0 0 0 .18-.31.38.38 0 0 0 0-.33c0-.09-.42-1-.58-1.37s-.3-.32-.41-.32h-.4a.72.72 0 0 0-.5.23 2.1 2.1 0 0 0-.65 1.55A3.59 3.59 0 0 0 5 8.2 8.32 8.32 0 0 0 8.19 11c.44.19.78.3 1.05.39a2.53 2.53 0 0 0 1.17.07 1.93 1.93 0 0 0 1.26-.88 1.67 1.67 0 0 0 .11-.88c-.05-.07-.17-.12-.36-.21z"></path>
                                          <path d="M13.29 2.68A7.36 7.36 0 0 0 8 .5a7.44 7.44 0 0 0-6.41 11.15l-1 3.85 3.94-1a7.4 7.4 0 0 0 3.55.9H8a7.44 7.44 0 0 0 5.29-12.72zM8 14.12a6.12 6.12 0 0 1-3.15-.87l-.22-.13-2.34.61.62-2.28-.14-.23a6.18 6.18 0 0 1 9.6-7.65 6.12 6.12 0 0 1 1.81 4.37A6.19 6.19 0 0 1 8 14.12z"></path>
                                      </g>
                                  </svg>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          </section>
        </div>
      </div>
    </Router>
  );
}

export default App;
